<template>
	<report-page
		:start-date="true"
		:end-date="true"
		get-url="/bo/report/finance/unpaidinvoicesreason"
		title="Unpaid invoices - reasons"
		export-filename="unpaid_invoices_reason"
	>
		<template #item.policyNumber=" { item }">
			<a :href="`/bo/orders/view?id=${item.id}`">
				{{ item.policyNumber }}
			</a>
		</template>
	</report-page>
</template>

<script>
export default {
	name: 'UnpaidInvoicesReasonReport'
};
</script>
